export const dateToString = (date) => {

  const mes = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sept","Oct","Nov","Dic"];
  let dia = date.getDate();
  if(dia<10){
    dia = '0'+dia;
  }
  let anio = date.getFullYear().toString();
  return dia+" "+mes[date.getMonth()]+" "+anio[2]+anio[3];
};

export const setShortFormart = (datePickerFormat) => {
  if(datePickerFormat!==null){
    let dateArr = datePickerFormat.split('-');
    let date = new Date(dateArr[0],dateArr[1]-1,dateArr[2]);
    return dateToString(date);
  }
  return false;
};

export const getMonth = (numMes)=>{
  const mes = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
  return mes[parseInt(numMes)-1];
};
export const apiDate= (date)=>{
  const mes = date.getMonth()+1;
  return date.getFullYear()+"-"+mes+"-"+date.getDate();
}

export const ObtnerSemanaAnterior = ()=>{
  let aux1 = new Date();
  let aux2 = new Date();
  let hoy = new Date(Date.now());

  let domingo = new Date(aux1.setDate(aux1.getDate() - hoy.getDay()));

  let lunes = new Date(aux2.setDate(aux2.getDate() - (hoy.getDay() + 6)));

  return {
    firstDate:lunes,
    secondDate:domingo,
  };
}

